// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.banner_banner__NyvIT {
  position: fixed;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  width: 80%;
  padding: 15px;
  text-align: center;
  font-weight: 600;
  border-radius: 5px;
  margin-bottom: 20px;
  z-index: 1000;
}

.banner_warning__sCUSf {
  position: static;
  transform: none;
  width: 100%;
  background-color: #fff3cd;
  color: #c89704;
  border: 1px solid #ffeeba;
}

.banner_success__1H0zA {
  background-color: #d4edda;
  color: #155724;
  border: 1px solid #c3e6cb;
}

.banner_error__OFsrh {
  background-color: #f8d7da;
  color: #721c24;
  border: 1px solid #f5c6cb;
}`, "",{"version":3,"sources":["webpack://./src/components/banner/banner.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,UAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;AACF;;AAEA;EACE,gBAAA;EACA,eAAA;EACA,WAAA;EACA,yBAAA;EACA,cAAA;EACA,yBAAA;AACF;;AAEA;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AACF;;AAEA;EACE,yBAAA;EACA,cAAA;EACA,yBAAA;AACF","sourcesContent":[".banner {\n  position: fixed;\n  top: 10px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 80%;\n  padding: 15px;\n  text-align: center;\n  font-weight: 600;\n  border-radius: 5px;\n  margin-bottom: 20px;\n  z-index: 1000;\n}\n\n.warning {\n  position: static;\n  transform: none;\n  width: 100%;\n  background-color: #fff3cd;\n  color: #c89704;\n  border: 1px solid #ffeeba;\n}\n\n.success {\n  background-color: #d4edda;\n  color: #155724;\n  border: 1px solid #c3e6cb;\n}\n\n.error {\n  background-color: #f8d7da;\n  color: #721c24;\n  border: 1px solid #f5c6cb;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"banner": `banner_banner__NyvIT`,
	"warning": `banner_warning__sCUSf`,
	"success": `banner_success__1H0zA`,
	"error": `banner_error__OFsrh`
};
export default ___CSS_LOADER_EXPORT___;
